import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import Factory from '@/Factories/Factory';
import ViewFactory from '@/Factories/ViewFactory';
export default class HomeViewFactory {
    public internalFactory: any;
    private DEFAULTFACTORY: any;
    private EMPTYFACTORY: any;
    private factory: any;
    private user: any;
    constructor(params: any) {
        this.DEFAULTFACTORY = 'StartpageView';
        this.EMPTYFACTORY = 'EmptyView';
        this.factory = RADApplication.getInstance().configuration.startpageUIFactory;
        this.user = RADApplication.getInstance().user;
        this.internalFactory = null;
        if (this.user.needsTwoFaRegistration()) {
            this.callEmptyFactory();
        } else {
            this.callBaseFactoryForHome(this.factory, params);
        }
    }
    private callEmptyFactory(): any {
        let factory = ComponentManager.getFactory<typeof ViewFactory>(this.EMPTYFACTORY);
        if (factory) {
            Object.setPrototypeOf(this, new factory({}));
            this.internalFactory = this.EMPTYFACTORY;
        } else {
            throw 'Es wurde keine "' + this.EMPTYFACTORY + '" als Startpage gefunden.';
        }
    }
    private callBaseFactoryForHome(factoryString: any, params: any): any {
        if (!String.isNullOrEmpty(factoryString)) {
            this.callBaseFactory(factoryString, params);
        } else {
            this.callDefaultBaseFactory(params);
        }
    }
    private callBaseFactory(queryString: any, params: any): any {
        let parser = Factory.parseUIGeneratorQuery(queryString);
        let options = _.extend(params || {}, parser.parameters);
        if (parser.uiGenerator === "Home") {
            this.callDefaultBaseFactory(params);
            return;
        }
        let BaseComponent = ComponentManager.getFactory<typeof ViewFactory>(parser.uiGenerator);
        if (BaseComponent) {
            Object.setPrototypeOf(this, new BaseComponent(options));
            this.internalFactory = parser.uiGenerator;
        }
        else {
            this.callDefaultBaseFactory(params);
        }
    }
    private callDefaultBaseFactory(params: any): any {
        let baseComponent = ComponentManager.getFactory<typeof ViewFactory>(this.DEFAULTFACTORY);
        if (baseComponent) {
            Object.setPrototypeOf(this, new baseComponent(params));
            this.internalFactory = this.DEFAULTFACTORY;
        }
        else {
            throw 'Es wurde keine "' + this.DEFAULTFACTORY + '" als Startpage gefunden.';
        }
    }
}

// Sonderfall... Eigentlich ist HomeViewFactory keine Factory
ComponentManager.setFactory('Home', HomeViewFactory as any, 'RADPresentation.HTMLClient.DefaultViewExtensions');